import { Component, forwardRef, Renderer2, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DepartmentService } from '../../../service/department/department.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectDepartmentComponent),
  multi: true,
};

@Component({
  selector: 'app-select-department',
  templateUrl: './select-department.component.html',
  styleUrls: ['./select-department.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectDepartmentComponent implements ControlValueAccessor, OnChanges {
    @Input() departmentId: number;
    @Input() departmentPosition: string;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();
    @Input() venue_id: string;
    @Input() deleteInnovationOptions: boolean = false;

    public departmentsOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public departmentService: DepartmentService
    ) {
        this.page = 1;
        this.per_page = 1000;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
    }

    ngOnInit() {
        if (this.departmentPosition) {
            this.filters.push({key: 'id-in', value: this.departmentPosition});
        }

        // if (this.venue_id) {
        //     this.filters.push({key: 'venue_id-in', value: this.venue_id});
        // }

        this.getDepartments(this.query, this.filters);
    }

    ngOnChanges() {
        this.filters = [];
        this.ngOnInit();
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onMyChange.emit($event.target.value);
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getDepartments(query?: string, filters?: any[]) {
        this.departmentService.getDepartment(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const departments = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.departmentsOptions = [];
                this.departmentsOptions.push({id: undefined, name: 'choose department'});
                departments.forEach(element => {
                    if(this.deleteInnovationOptions) {
                        if(element.id != '42') {
                            if (this.departmentId == element.id)
                                this.departmentsOptions.push({id: element.id, name: element.name, selected: true});
                            else
                                this.departmentsOptions.push({id: element.id, name: element.name, selected: false});
                        }
                    } else {
                        if (this.departmentId == element.id)
                            this.departmentsOptions.push({id: element.id, name: element.name, selected: true});
                        else
                            this.departmentsOptions.push({id: element.id, name: element.name, selected: false});
                    }
                });
            },
            error => {
                this.departmentsOptions = [];
                this.departmentsOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/departments/select-department/select-department.component.ts